<!-- ATLAS-702 Reporting - BETA Services - view file -->
<template>
  <div class="_report">
    <ElasticList :list="list" :rawFilter="filter" ref="elasticListRef" />
  </div>
</template>

<script>
import ElasticList from "@/components/DynamicForm/ElasticList";
import ReportBetaServicesConfig from "./include/configs/ReportBetaServicesConfig";
import ReportConfigDefaults from "./include/configs/ReportConfigDefaults";

export default {
  components: {
    ElasticList
  },
  data() {
    return {
      filter: {},
      list: ReportBetaServicesConfig(this),
      services: []
    };
  },
  beforeMount() {
    this.filter = {
      filter: {
        esQuery: JSON.stringify({
          bool: {
            must: [{ match: { beta: true } }]
          }
        })
      }
    };
  }
};
</script>
